import type { GeometryPadWidgetConfig } from '../geometrypad.model';

/** Preset 1: Arc Basics — single arc with center, radius, central angle labeled */
export const ARC_BASICS_PRESET: GeometryPadWidgetConfig = {
  id: 'arc-basics',
  type: 'geometrypad',
  params: {
    elements: {
      a1: {
        type: 'Arc',
        params: { r: 4, centralAngle: 120 },
      },
    },
  },
  display: {
    geometry: {
      label: { names: 'all', values: 'all', coloring: true },
    },
    elements: {
      a1: {
        subparts: {
          centralAngle: { visible: true },
        },
      },
    },
  },
};

/** Preset 2: Sector & Segment — shows sector fill and chord */
export const ARC_SECTOR_SEGMENT_PRESET: GeometryPadWidgetConfig = {
  id: 'arc-sector-segment',
  type: 'geometrypad',
  params: {
    elements: {
      a1: {
        type: 'Arc',
        params: { r: 4, centralAngle: 150 },
      },
    },
  },
  display: {
    geometry: {
      label: { names: 'all', values: 'all', coloring: true },
    },
    elements: {
      a1: {
        subparts: {
          sector: { visible: true },
          chord: { visible: true },
        },
      },
    },
  },
};

/** Preset 3: Arc Length Formula — demonstrates s = rθ */
export const ARC_LENGTH_FORMULA_PRESET: GeometryPadWidgetConfig = {
  id: 'arc-length-formula',
  type: 'geometrypad',
  params: {
    variables: { theta: 90 },
    elements: {
      a1: {
        type: 'Arc',
        params: { r: 3, centralAngle: 'theta' },
      },
    },
  },
  display: {
    geometry: {
      label: { names: 'all', values: 'all', coloring: true },
    },
    elements: {
      a1: {
        subparts: {
          centralAngle: { visible: true },
        },
      },
    },
  },
  behavior: {
    controls: [{ id: 'theta', type: 'slider', label: 'θ (°)', param: 'theta', range: [10, 350, 5], defaultValue: 90 }],
  },
};

/** Preset 4: Sector Area — demonstrates A = ½r²θ */
export const ARC_SECTOR_AREA_PRESET: GeometryPadWidgetConfig = {
  id: 'arc-sector-area',
  type: 'geometrypad',
  params: {
    variables: { theta: 120 },
    elements: {
      a1: {
        type: 'Arc',
        params: { r: 4, centralAngle: 'theta' },
      },
    },
  },
  display: {
    geometry: {
      label: { names: 'all', values: 'all', coloring: true },
    },
    elements: {
      a1: {
        subparts: {
          sector: { visible: true },
          centralAngle: { visible: true },
        },
      },
    },
  },
  behavior: {
    controls: [{ id: 'theta', type: 'slider', label: 'θ (°)', param: 'theta', range: [10, 350, 5], defaultValue: 120 }],
  },
};

/** Preset 5: Two arcs on same circle showing equal chord lengths for equal central angles */
export const ARC_CHORD_RELATIONSHIP_PRESET: GeometryPadWidgetConfig = {
  id: 'arc-chord-relationship',
  type: 'geometrypad',
  params: {
    elements: {
      a1: {
        type: 'Arc',
        params: { r: 4, startAngle: 30, centralAngle: 80 },
      },
      a2: {
        type: 'Arc',
        params: { r: 4, startAngle: 180, centralAngle: 80 },
      },
    },
  },
  display: {
    geometry: {
      label: { names: 'all', values: 'all', coloring: true },
    },
    elements: {
      a1: {
        circle: { strokeColor: 'sky' },
        subparts: {
          chord: { visible: true, line: { color: 'sky' } },
        },
      },
      a2: {
        circle: { strokeColor: 'indigo' },
        subparts: {
          chord: { visible: true, line: { color: 'indigo' } },
        },
      },
    },
  },
};

/** Preset 6: Simple single arc (minimal, like single-circle) */
export const SINGLE_ARC_PRESET: GeometryPadWidgetConfig = {
  id: 'single-arc',
  type: 'geometrypad',
  params: {
    elements: {
      a1: {
        type: 'Arc',
        params: { r: 4, centralAngle: 90 },
      },
    },
  },
  display: {
    geometry: {
      label: { coloring: true },
    },
  },
};
